import React from 'react';
import './SocialFeature.css';

const TwitterFeature = () => {
    const twitterUrl = "https://twitter.com/journey2twunk";

    return (
        <div className="social-feature">
            <h2>Twitter Feed</h2>
            {/* Add Twitter embed code here */}
            <a 
                href={twitterUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="social-button twitter-button"
            >
                Follow Me on Twitter
            </a>
        </div>
    );
};

export default TwitterFeature;
